import React from "react";

export interface IndexHeaderProps {

	title?: string;

	children: React.ReactNode;

}

const IndexHeader: React.FC<IndexHeaderProps> = (props: IndexHeaderProps) => {

	return (
		<>
			<div id="indexheader-container" className="w-full flex flex-col justify-left items-left">
				{props.title && (
					<div id="indexheader-header" className="pb-2 w-full">
						{props.title}
					</div>
				)}
				<div id="indexheader-description" className="pb-8 w-2/3">
					{props.children}
				</div>
			</div>
		</>
	);

};

export default IndexHeader;